import React, { useState, useEffect } from "react";
import ActionCenter from "./ActionCenter";
import RenderDeliveryGroupMapping from './RenderDeliveryGroupMapping'

import { useLocation, useNavigate } from "react-router-dom";
import { Msg200or201, Msg204, Msg400, Msg401, Msg409, Msg403, Msg500 } from '../../Messages/Messages';
import { decryptData } from "../../../utils/storageCrypto";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const steps = [
  "Create Delivery Group",
  "Initiate Billing",
  "Bill Generated",
  "Generate Invoice",
  "Invoice Generated",
  "Ready for Delivery",
];

const OrderFullfillmentFlow = () => {
  const navigate = useNavigate()
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [deliveryGroup, setDeliveryGroup] = useState();
  const [deliveryGroups, setDeliveryGroups] = useState([]);
  const [activeStep, setActiveStep] = useState(1);
  const location = useLocation();
  const { delivery_group_id, order_data, all_delivery_groups } = location.state || ''
  
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [activeDeliveryGroupId, setActiveDeliveryGroupId] = useState(delivery_group_id);
  const [isStepLoading, setIsStepLoading] = useState(false);
  const [isDeliveryGroupLoading, setIsDeliveryGroupLoading] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const FetchOrderbyID = async () => {
    try {
      setIsDeliveryGroupLoading(true);
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      if (!all_delivery_groups || all_delivery_groups.length === 0) return;

      const dgPromises = all_delivery_groups.map(dg =>
        fetch(
          `${fetchUrl}customer/salesorder/get-delivery-group-details?delivery_group_id=${dg._id}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-token': token,
            },
          }
        ).then(res => res.json())
      );

      const results = await Promise.all(dgPromises);
      const fetchedDGs = results.map(r => r?.data).filter(Boolean);
      
      setDeliveryGroups(fetchedDGs);
      
      const currentActive = fetchedDGs.find(d => d._id === activeDeliveryGroupId) || fetchedDGs[0];
      setDeliveryGroup(currentActive);
    } catch (error) {
      console.error('Error fetching order data:', error);
      setDeliveryGroups([]);
    } finally {
      setIsDeliveryGroupLoading(false);
    }
  };

  useEffect(() => {
    if (all_delivery_groups?.length > 0) {
      FetchOrderbyID();
    }
  }, []);

  useEffect(() => {
    if (deliveryGroups.length > 0) {
      const currentActive = deliveryGroups.find(d => d._id === activeDeliveryGroupId);
      if (currentActive) setDeliveryGroup(currentActive);
    }
  }, [activeDeliveryGroupId, deliveryGroups]);

  useEffect(() => {
    if (deliveryGroup) {
      const isReadyForDelivery = deliveryGroup?.sub_orders?.[0]?.status === "Ready For Delivery"; 

      if (isReadyForDelivery) {
        setActiveStep(7);
      } else if (deliveryGroup.invoice_status === 'Invoice Generated') {
        setActiveStep(6);
      } else if (deliveryGroup.billing_status === 'Billed' && deliveryGroup.bill_accepted_status?.toLowerCase() === 'accepted') {
        setActiveStep(4);
      } else if (deliveryGroup.billing_status === 'Billed') {
        setActiveStep(3);
      } else if (deliveryGroup.billing_status === 'Ready To Bill' || deliveryGroup.billing_status === 'Initiated') {
        setActiveStep(2);
      } else {
        setActiveStep(1); 
      }
    }
  }, [deliveryGroup]);

  useEffect(() => {
    setIsStepLoading(true);
    const timer = setTimeout(() => {
      setIsStepLoading(false);
    }, 400); 

    return () => clearTimeout(timer);
  }, [activeStep]);

  const closePopup = () => setShowPopup(false);
  const Retry = () => setShowPopup(false);
  const BackToLoginPage = () => {
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
    navigate('/bb');
  };

  return (
    <div className="flex h-screen">
      <div className="relative flex-1 h-full flex flex-col min-w-0">
        {isRefreshing ? (
          <div className="absolute inset-0 z-50 flex justify-center items-start pt-20 bg-white/70 backdrop-blur-sm">
            <div className="flex space-x-2">
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
            </div>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto relative flex flex-col">
              <div className="sticky top-0 z-30 border border-gray-200 rounded-md mx-6 mt-4 bg-gray-50 mb-4">
                <div className="flex items-center text-sm text-gray-700">
                  <div className="mr-2 ml-4 cursor-pointer">
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      className="text-gray-700 text-md hover:text-black"
                      onClick={() => navigate("/bb/app/home", { state: { activeTab: "orders" } })}
                    />
                  </div>

                  <div className="px-6 py-3">
                    <div className="flex items-center text-sm text-gray-700">
                      <div className="pr-6">
                        <p className="text-xs text-gray-500">Order Number</p>
                        <p className="font-semibold mt-1">{order_data?.orderNumber}</p>
                      </div>
                      <div className="h-8 w-px bg-gray-200 mx-6" />
                      <div className="pr-6">
                        <p className="text-xs text-gray-500">Status</p>
                        <p className="font-semibold mt-1">{order_data?.status}</p>
                      </div>
                      <div className="h-8 w-px bg-gray-200 mx-6" />
                      <div>
                        <p className="text-xs text-gray-500">Created At</p>
                        <p className="font-semibold mt-1">
                          {(() => {
                            const orderDate = new Date(order_data?.orderDate);
                            return `${orderDate.toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" })}, ${orderDate.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true })}`;
                          })()}
                        </p>
                      </div>
                      <div className="h-8 w-px bg-gray-200 mx-6" />
                      
                      {Array.isArray(all_delivery_groups) && all_delivery_groups.length > 0 && (
                        <div className="mt-3 flex gap-3 flex-wrap">
                          {all_delivery_groups.map((dg) => (
                            <button
                              key={dg._id}
                              onClick={() => {
                                setActiveDeliveryGroupId(dg._id);
                                document.getElementById(`dg-${dg._id}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                              }}
                              className={`px-3 py-1 text-sm rounded-full border transition
                                ${activeDeliveryGroupId === dg._id
                                  ? "bg-blue-600 text-white border-blue-600"
                                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                                }`}
                            >
                              {dg.delivery_group_number}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="sticky top-[80px] z-40 bg-white relative mb-6 mt-2">
                <div
                  className="absolute top-6 h-[2px] bg-gray-300 z-0"
                  style={{ left: `${50 / steps.length}%`, right: `${50 / steps.length}%`, width: steps.length > 1 ? `calc(100% - ${100 / steps.length}%)` : "0%" }}
                />
                <div
                  className="absolute top-6 h-[2px] bg-green-500 z-10 transition-all duration-500 ease-in-out"
                  style={{ left: `${50 / steps.length}%`, width: activeStep <= 1 ? "0%" : `calc(((100% - ${100 / steps.length}%) / ${steps.length - 1}) * ${activeStep - 1})` }}
                />
                <div className="flex justify-between relative z-20">
                  {steps.map((label, index) => {
                    const step = index + 1;
                    const isCompleted = step < activeStep || (step === 6 && activeStep === 7);
                    const isActive = step === activeStep || (step === 6 && activeStep === 7);

                    return (
                      <div key={label} className={`flex flex-col items-center flex-1 cursor-pointer ${step === 1 ? "-ml-6" : step === steps.length ? "ml-6" : ""}`}>
                        <div
                          className={`w-12 h-12 rounded-full flex items-center justify-center shadow-md border-2 transition-all duration-300
                            ${isCompleted
                              ? "bg-green-500 border-green-500 scale-110"
                              : isActive
                                ? "bg-white border-blue-700 shadow-lg scale-105"
                                : "bg-white border-gray-300 hover:border-gray-400"
                            }`}
                        >
                          {isCompleted ? (
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                          ) : (
                            <span className={`font-bold text-sm ${isActive ? "text-blue-600" : "text-gray-400"}`}>{step}</span>
                          )}
                        </div>
                        <p className={`mt-2 text-xs font-medium text-center transition-colors duration-300 ${isCompleted ? "text-green-600 font-semibold" : isActive ? "text-blue-600 font-semibold" : "text-gray-400"}`}>
                          {label}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="px-6 py-4 mb-2 flex-1">
                {(isStepLoading || isDeliveryGroupLoading) && (
                  <div className="flex w-full justify-center bg-opacity-50">
                    <div className="flex space-x-2 w-full justify-center items-center h-20">
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
                    </div>
                  </div>
                )}
                {!isStepLoading && !isDeliveryGroupLoading && deliveryGroups.length > 0 && (
                  <div className="flex flex-col gap-6 scroll-smooth">
                    {deliveryGroups.map(dg => (
                      <div key={dg._id} id={`dg-${dg._id}`}>
                        <RenderDeliveryGroupMapping
                          deliveryGroup={dg}
                          handleGetDg={FetchOrderbyID}
                          setShowPopup={setShowPopup}
                          setPopupType={setPopupType}
                          setPopupMessage={setPopupMessage}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {showPopup && (
        <div className="z-[999]">
          {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
          {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
          {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '409' && <Msg409 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
        </div>
      )}
    </div>
  );
};

export default OrderFullfillmentFlow;